import React from 'react';
import { Box } from '@mui/material';
import Header from '../../../shared/Header/Header';
import MissionVisionTextBlock from '../MissionVisionTextBlock/MissionVisionTextBlock';
import { aboutMissionVisionSectionStyles } from './AboutMissionVisionSection.styles';
import Villa1 from '../../../../assets/about/Villa1.png';
import Villa2 from '../../../../assets/about/Villa2.png';
import WavePng from '../../../../assets/Wave.png';
import InfoCard from '../../../../components/InfoCard/InfoCard';

const AboutMissionVisionSection = () => {
  const styles = aboutMissionVisionSectionStyles;

  return (
    <Box sx={styles.container}>
      {/* Header with same feel as Home hero header */}
      <Box sx={styles.headerContainer}>
        <Header isSecondary={true} />
      </Box>

      <Box sx={styles.sectionsWrapper}>
        {/* Top 100vh - Mission */}
        <Box sx={styles.halfSection}>
          <Box sx={styles.waveBackground(WavePng)} />
          <Box sx={styles.textColumn}>
            <MissionVisionTextBlock
              heading="Mission"
              title="Elevating the Way People Stay"
              body="Our mission is to curate and manage premium residences that offer comfort, consistency, and peace of mind. We focus on thoughtful selection, refined standards, and attentive management to ensure every stay feels seamless, welcoming, and considered from start to finish."
            />
          </Box>
          <Box sx={styles.imageColumn}>
            <Box sx={styles.imageWrapper}>
              <img src={Villa1} alt="Villa 1" style={styles.image} loading="lazy" />
                <Box sx={styles.infoCard1}>
                <InfoCard title="50+" subtitle="Managed Properties" />
              </Box>
              <Box sx={styles.infoCard2}>
                <InfoCard title="+40k" subtitle="Satisfied customers" />
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Bottom 100vh - Vision */}
        <Box sx={styles.halfSection} mt={{xs: "50px", lg: 0}}>
          <Box sx={styles.waveBackgroundRotated(WavePng)} />
          <Box sx={styles.visionImageColumn}>
            <Box sx={styles.image2Wrapper}>
              <Box sx={styles.image2} component="img" src={Villa2} alt="Villa 2" loading="lazy"></Box>
              <Box sx={styles.infoCard3}>
                <InfoCard title="92%" subtitle="Occupancy Rate" />
              </Box>
            </Box>
          </Box>
          <Box sx={styles.visionTextColumn}>
            <MissionVisionTextBlock
              heading="Vision"
              title="Our Vision for Elevated Living"
              body="Our vision is to redefine premium stays by setting a new benchmark for quality, care, and experience. We aspire to create a trusted collection of refined residences where thoughtful design, comfort, and attention to detail come together to elevate everyday living."
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutMissionVisionSection;


